;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { PageError } from '@qogita/ui/page-error'
import { Anchor } from '@qogita/ui/v2/anchor'
import NextLink from 'next/link'
import { SupportEmailLink } from 'src/deprecated/components/shared/EmailLinks'
import { Seo } from 'src/deprecated/components/shared/Seo'
import { PublicLayout } from 'src/deprecated/components/shared/templates/PublicLayout'
import { useUserContext } from 'src/deprecated/contexts/User'
import { useLandingRoute } from 'src/deprecated/hooks/utils/useLandingRoute'
import { Page } from 'src/deprecated/types/next'

const Custom404: Page = () => {
  const landingRoute = useLandingRoute()
  const user = useUserContext()

  const pageErrorUrl = user ? landingRoute : '/'

  const returnHomeAnchor = (
    <Anchor href="/" variant="inline-text">
      sellers.qogita.com
    </Anchor>
  )

  return (
    <>
      <Seo title="Page not found" />

      <div className="my-[10vh]">
        <div className="flex justify-center">
          <NextLink href={pageErrorUrl}>
            <PageError.Logo />
          </NextLink>
        </div>

        <div className="text-center">
          <PageError.Title className="mt-5 mb-2">
            We can’t find this page
          </PageError.Title>

          <PageError.Code httpCode="404" className="mb-5" />

          <p className="mx-auto max-w-lg text-base">
            Click here to return to {returnHomeAnchor}. Please contact{' '}
            <SupportEmailLink /> if the issue continues.
          </p>
        </div>
      </div>
    </>
  )
}

Custom404.options = {
  public: true,
  getLayout: (page) => <PublicLayout pageBlok={null}>{page}</PublicLayout>,
}

export default Custom404
